import { observer } from 'mobx-react-lite'
import { type CouponSelectionViewModel } from '@/features/jobs/drafting/CouponSelectionViewModel'
import { CouponSelection } from '@/features/jobs/drafting/components/JobCreation/Submission/CouponSelection'

export interface CouponSelectionContainerProps {
  vm: CouponSelectionViewModel
  compact?: boolean
  testId?: string
}

export const CouponSelectionContainer = observer(
  function CouponSelectionContainer({
    vm,
    compact,
    testId,
  }: CouponSelectionContainerProps) {
    return (
      <CouponSelection
        selectedCoupon={
          vm.selected
            ? { code: vm.selected.code, description: vm.selected.description }
            : null
        }
        isDisabled={vm.disabled || vm.isPending}
        isRemovePending={vm.remove.pending}
        onShow={vm.showDialog}
        onRemove={vm.remove}
        compact={compact}
        testId={testId}
      />
    )
  },
)
